import { ElementRef, Injectable, OnDestroy } from '@angular/core'
import { BehaviorSubject, Subscription } from 'rxjs'
import { BaseSite, BaseSiteService, Country, SiteConnector, WindowRef } from '@spartacus/core'
import { filter, map, switchMap } from 'rxjs/operators'
import { UntypedFormGroup } from '@angular/forms'

@Injectable({
  providedIn: 'root'
})
export class MbCheckoutCommonService implements OnDestroy {
  private userCountryObject = new BehaviorSubject<Country>({})
  userCountry = this.userCountryObject.asObservable()
  subscription: Subscription = new Subscription()

  constructor (protected baseSiteService: BaseSiteService,
               protected siteConnector: SiteConnector) {
    this.setUsersCountry()
  }

  ngOnDestroy (): void {
    this.subscription?.unsubscribe()
  }

  setUsersCountry (): void {
    this.subscription.add(this.baseSiteService.getActive().pipe(
      filter((activeSite: string) => !!activeSite),
      switchMap((activeSite: string) => this.siteConnector.getBaseSite(activeSite)),
      filter((baseSite: BaseSite | undefined) => !!baseSite),
      map((baseSite: any) => baseSite?.country)
    ).subscribe(country => {
      this.userCountryObject.next(country)
    }))
  }

  scrollToError (form: UntypedFormGroup, el: ElementRef, winRef: WindowRef) {
    const firstError = el.nativeElement.querySelector('input.ng-invalid')
    firstError?.focus()
    winRef.nativeWindow?.scroll({ top: firstError.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' })
  }
}
